import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuardGuard } from './services/auth/auth-guard.guard';
import { AuthLoggedGuard } from './services/auth/auth-logged-guard';
import { PageNotFoundComponent } from './modules/page-not-found/page-not-found.component';

const routes: Routes = [
  {
    path: '',
    loadChildren: () =>
      import('./modules/account/account.module').then((m) => m.AccountModule),
    canActivate: [AuthGuardGuard],
  },
  {
    path: 'privacy',
    loadChildren: () =>
      import('./pages/privacy-policy/privacy-policy-routing.module').then(
        (m) => m.PrivacyPolicyRoutingModule
      ),
  },
  {
    path: 'auth',
    loadChildren: () =>
      import('./modules/auth/auth.module').then((m) => m.AuthModule),
    canActivate: [AuthLoggedGuard],
  },
  {
    path: 'earn',
    loadChildren: () =>
      import('./pages/earn/earn.module').then((m) => m.EarnModule),
  },
  {
    path: 'donation',
    loadChildren: () =>
      import('./pages/donation-page/donation-page.module').then(
        (m) => m.DonationPageModule
      ),
  },
  {
    path: '**',
    component: PageNotFoundComponent,
  },
  {
    path: '',
    redirectTo: '',
    pathMatch: 'full',
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { scrollPositionRestoration: 'enabled' }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
